import { css } from 'styled-components'

export const count = css`
  ${Array.from(Array(100)).map((_, i) => css`
    &:nth-child(${i}){
      --count: ${i};
    }
  `)}
`